import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "../../webcss/invoice.css";
import { POST_AEPS_TRANSACTION_INVOICE } from "../../Utils/appConstants";
import { getUTCToLocalDateTimeFormat } from "../../Utils/function";
import { postRequest } from "../../Utils/AppApi";
import { aepsServiceInArray, aepsStatus } from '../../Utils/Common';

function AepsInvoice(props) {
  const history = useHistory();

  const [idata, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [isPrintButton, setPrintButton] = useState(true);

  const { isPageView = false, transactionId } = props;

  const print = () => {
    setPrintButton(false);
    setTimeout(() => {
      window.print();
      setPrintButton(true);
    }, 100);
  };

  const handleInvoice = () => {
    setLoading(true);

    postRequest(
      POST_AEPS_TRANSACTION_INVOICE,
      { transactionId },
      history
    )
      .then((response) => {
        if (response.success) {
          setData(response.data || {});
        } else {
          setData({});
        }
      })
      .catch(() => setData({}))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (transactionId) {
      handleInvoice();
    }
  }, [transactionId]);

  if (loading) {
    return (
      <div className="compact-loading-invoice">
        <div className="compact-spinner-invoice"></div>
        <p>Loading receipt details...</p>
      </div>
    );
  }

  return (
    <div className="compact-invoice-container">

      {/* ===== HEADER ===== */}
      <div className="compact-invoice-header">
        <div className="compact-brand">
          <div className="compact-logo">
            <img
              src="../logo.png"
              alt="Logo"
              className="brand-image"
              style={{ opacity: ".8" }}
            />
          </div>
        </div>

        <div className="compact-brand-info">
          {/* <h4 className="compact-company-name">
            Customer Name : {idata?.userData?.name || "N/A"}
          </h4> */}
          <p className="compact-transaction-ref">
            Mobile No : {idata?.mobile || "N/A"}
          </p>
          <p className="compact-transaction-ref">
            Aadhaar : ********{idata?.aadhaar || "N/A"}
          </p>
          <p className="compact-transaction-ref">Date & Time : {getUTCToLocalDateTimeFormat(idata?.createdAt) || 'N/A'}</p>

        </div>
      </div>

      {/* ===== INFO GRID ===== */}
      <div className="compact-info-grid">

        {/* Bank Info */}
        <div className="compact-info-card">
          <div className="compact-card-header">
            <i className="fa fa-university fa-sm"></i>
            <h5>Bank Details</h5>
          </div>

          <div className="compact-card-body">
            <div className="compact-info-row">
              <span className="compact-info-label">Bank:</span>
              <span className="compact-info-value">{idata?.bankName || "N/A"}</span>
            </div>

            <div className="compact-info-row">
              <span className="compact-info-label">Account Balance :</span>
              <span className="compact-info-value">{idata?.bankAccountBalance || "N/A"}</span>
            </div>

            <div className="compact-info-row">
              <span className="compact-info-label">Service:</span>
              <span className="compact-info-value">{idata?.mode}</span>
            </div>
          </div>
        </div>

        {/* Outlet / Agent */}
        <div className="compact-info-card">
          <div className="compact-card-header">
            <i className="fa fa-store fa-sm"></i>
            <h5>Outlet</h5>
          </div>

          <div className="compact-card-body">
            <div className="compact-info-row">
              <span className="compact-info-label">Agent:</span>
              <span className="compact-info-value">
                {idata?.userData?.name}
              </span>
            </div>

            <div className="compact-info-row">
              <span className="compact-info-label">Username:</span>
              <span className="compact-info-value">
                {idata?.userData?.username}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ===== TRANSACTION TABLE (SINGLE ROW) ===== */}
      <div className="compact-transaction-section">
        <div className="compact-table">
          <div className="compact-table-header">
            <div className="compact-th">Date & Time</div>
            <div className="compact-th">Txn ID</div>
            <div className="compact-th">Bank RRN</div>
            <div className="compact-th">Amount</div>
            <div className="compact-th">Status</div>
          </div>

          <div className="compact-table-row">
            <div className="compact-td">
              {getUTCToLocalDateTimeFormat(idata?.updatedAt)}
            </div>

            <div className="compact-td">
              <span className="compact-amount">{idata?.transactionId}</span>
            </div>

            <div className="compact-td">
              <span className="compact-amount">{idata?.bankRRN || "-"}</span>
            </div>

            <div className="compact-td">
              <span className="compact-amount">₹{idata?.amount}</span>
            </div>

            <div className="compact-td">
              <span
                className={`compact-status-badge ${idata?.status === 1
                    ? "success"
                    : idata?.status === 2
                      ? "failed"
                      : "pending"
                  }`}
              >
                {aepsStatus(idata?.status)}
                {/* {idata?.statusText || "Pending"} */}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ===== FOOTER ===== */}
      <div className="compact-footer">
        <div className="compact-footer-note">
          <i className="fa fa-info-circle fa-sm"></i>
          Computer generated receipt - No signature required
        </div>

        {isPageView && isPrintButton && (
          <button onClick={print} className="compact-print-btn">
            <i className="fa fa-print"></i> Print Receipt
          </button>
        )}
      </div>
    </div>
  );
}

export default AepsInvoice;
